/// <reference types="./analytics.d.mts" />
import * as $bright from "../../../bright/bright.mjs";
import * as $metrics from "../../../common/data/metrics.mjs";
import * as $user from "../../../common/data/user.mjs";
import * as $month from "../../../common_common/gleam/time/calendar/month.mjs";
import * as $colors from "../../../ds/ds/colors.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../ds/ds/components/profile_picture.mjs";
import * as $tooltip from "../../../ds/ds/components/tooltip.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $calendar from "../../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $h from "../../../lustre/lustre/element/html.mjs";
import * as $random from "../../../prng/prng/random.mjs";
import * as $seed from "../../../prng/prng/seed.mjs";
import * as $model from "../../data/model.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $charts from "../../elements/charts.mjs";
import * as $dataset from "../../elements/charts/dataset.mjs";
import * as $common from "../../frontend/view/common.mjs";
import * as $s from "../../frontend/view/styles/analytics.mjs";
import { toList, prepend as listPrepend, CustomType as $CustomType, isEqual } from "../../gleam.mjs";

export class DisplayCurve extends $CustomType {
  constructor(data_labels, data_bars, title) {
    super();
    this.data_labels = data_labels;
    this.data_bars = data_bars;
    this.title = title;
  }
}

function empty_data(title) {
  return $s.section(
    toList([$a.style("align-items", "start")]),
    toList([
      $s.section_title(toList([]), toList([$h.text(title)])),
      $s.statistics_content_wrapper_size(
        toList([]),
        toList([$s.statistics_content(toList([]), toList([$h.text("no data")]))]),
      ),
    ]),
  );
}

export function pie_plot(data1, data2) {
  let no_data = ($list.length(data1.data_bars) + $list.length(data1.data_bars)) === 0;
  return $bool.lazy_guard(
    no_data,
    () => { return empty_data(data1.title); },
    () => {
      let _block;
      let _pipe = data1.data_bars;
      let _pipe$1 = $list.last(_pipe);
      _block = $result.unwrap(_pipe$1, 0.0);
      let value1 = _block;
      let _block$1;
      let _pipe$2 = data2.data_bars;
      let _pipe$3 = $list.last(_pipe$2);
      _block$1 = $result.unwrap(_pipe$3, 0.0);
      let value2 = _block$1;
      let sum = $float.add(value1, value2);
      let _block$2;
      let _pipe$4 = $float.divide(value1, sum);
      let _pipe$5 = $result.unwrap(_pipe$4, 0.0);
      let _pipe$6 = $float.multiply(_pipe$5, 100.0);
      _block$2 = $float.ceiling(_pipe$6);
      let percent1 = _block$2;
      let _block$3;
      let _pipe$7 = $float.divide(value2, sum);
      let _pipe$8 = $result.unwrap(_pipe$7, 0.0);
      let _pipe$9 = $float.multiply(_pipe$8, 100.0);
      _block$3 = $float.ceiling(_pipe$9);
      let percent2 = _block$3;
      return $s.section(
        toList([$a.style("align-items", "start")]),
        toList([
          $s.section_title(toList([]), toList([$h.text(data1.title)])),
          $s.statistics_content_wrapper_size(
            toList([]),
            toList([
              $s.statistics_content(
                toList([]),
                toList([
                  $charts.pie(
                    toList([
                      new $dataset.Dataset(
                        toList([
                          $colors.light.blue_600,
                          $colors.light.success_600,
                        ]),
                        toList([percent2, percent1]),
                        toList([]),
                      ),
                    ]),
                  ),
                  $s.statistics_wrapper(
                    toList([]),
                    toList([
                      $s.statistics_value(
                        toList([]),
                        toList([
                          $s.statistics_label(
                            toList([]),
                            toList([
                              $s.statistics_color($colors.light.success_600),
                              $h.text(data1.title),
                            ]),
                          ),
                          $h.text($float.to_string(percent1) + "%"),
                        ]),
                      ),
                      $s.statistics_value(
                        toList([]),
                        toList([
                          $s.statistics_label(
                            toList([]),
                            toList([
                              $s.statistics_color($colors.light.blue_600),
                              $h.text(data2.title),
                            ]),
                          ),
                          $h.text($float.to_string(percent2) + "%"),
                        ]),
                      ),
                      $common.separator(),
                      $s.statistics_value(
                        toList([]),
                        toList([
                          $s.statistics_colored_label(
                            $colors.light.success_600,
                            toList([]),
                            toList([$h.text("# " + data1.title)]),
                          ),
                          $h.text($int.to_string($float.round(value1))),
                        ]),
                      ),
                      $s.statistics_value(
                        toList([]),
                        toList([
                          $s.statistics_colored_label(
                            $colors.light.blue_600,
                            toList([]),
                            toList([$h.text("# " + data2.title)]),
                          ),
                          $h.text($int.to_string($float.round(value2))),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function bar_plot(data) {
  let no_data = $list.is_empty(data.data_bars);
  return $bool.lazy_guard(
    no_data,
    () => { return empty_data(data.title); },
    () => {
      return $s.section(
        toList([$a.style("align-items", "start")]),
        toList([
          $s.section_title(toList([]), toList([$h.text(data.title)])),
          $s.statistics_content_wrapper_size(
            toList([]),
            toList([
              $s.statistics_content(
                toList([]),
                toList([
                  $charts.bar(
                    "vertical",
                    toList([
                      new $dataset.Dataset(
                        $list.repeat(
                          $colors.light.grey_200,
                          $list.length(data.data_bars),
                        ),
                        data.data_bars,
                        data.data_labels,
                      ),
                    ]),
                    [480, 240],
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function generate_fake_progress() {
  let generator = $random.float(0.0, 100.0);
  let answers_validated = $float.round(
    $random.sample(generator, $seed.random()),
  );
  let answers_in_review = 100 - answers_validated;
  return [answers_validated, answers_in_review];
}

function progress_bar_half(position, kind, width, content, tooltip) {
  let width$1 = $int.to_string(width) + "%";
  let style = toList([
    $a.style("width", width$1),
    $a.style("transition", "all .2s"),
  ]);
  let _block;
  if (kind instanceof $s.Validated) {
    _block = $colors.light.success_600;
  } else {
    _block = $colors.light.blue_600;
  }
  let color = _block;
  return $tooltip.tooltip(
    listPrepend($tooltip.position(position), style),
    $s.progress_bar_element(color, kind, toList([$h.text(content)])),
    $s.progress_bar_tooltip(toList([]), toList([$h.text(tooltip)])),
  );
}

export function view_user_progress_bar(user) {
  let $ = generate_fake_progress();
  let answers_validated = $[0];
  let answers_in_review = $[1];
  let validated = $int.to_string(answers_validated);
  let in_review = $int.to_string(answers_in_review);
  return $l.fragment(
    toList([
      $common.name_small(
        toList([]),
        toList([
          $pp.from_user(user.picture, user.initials, new $pp.Medium()),
          $el.text(user.name),
        ]),
      ),
      $s.progress_bar(
        toList([]),
        toList([
          progress_bar_half(
            $tooltip.left,
            new $s.Validated(),
            answers_validated,
            validated + " questions validated",
            ("There is " + validated) + " questions validated",
          ),
          progress_bar_half(
            $tooltip.right,
            new $s.InReview(),
            answers_in_review,
            in_review + " questions in review",
            ("There is " + in_review) + " questions in review",
          ),
        ]),
      ),
    ]),
  );
}

export function progress_per_collaborator(users) {
  return $s.section(
    toList([$a.style("align-items", "start")]),
    toList([
      $s.section_title(
        toList([]),
        toList([$h.text("Progress per collaborator")]),
      ),
      $s.statistics_content_wrapper(
        toList([$a.style("width", "100%")]),
        toList([
          $s.statistics_content(
            toList([]),
            toList([
              $s.progress_content_wrapper(
                toList([]),
                $list.map(
                  users,
                  (user) => { return view_user_progress_bar(user); },
                ),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

function empty_display() {
  return new DisplayCurve(toList([]), toList([]), "No data");
}

function display_date_int(day_or_month) {
  let v = day_or_month;
  if (v < 10) {
    return "0" + $int.to_string(v);
  } else {
    let v$1 = day_or_month;
    return $int.to_string(v$1);
  }
}

function display_date(date) {
  let day = display_date_int(date.day);
  let month = display_date_int($month.to_int(date.month));
  return $string.join(toList([day, month]), "/");
}

function process_curve(curve) {
  let title = curve.curve.data.name;
  let data_bars = $list.map(curve.metrics, (m) => { return m.value; });
  return new DisplayCurve(
    $list.map(
      curve.metrics,
      (m) => {
        let $ = $timestamp.to_calendar(m.created_at, $calendar.utc_offset);
        let date = $[0];
        return display_date(date);
      },
    ),
    data_bars,
    title,
  );
}

function find_curve(curves, kind) {
  let _pipe = curves;
  let _pipe$1 = $list.find(
    _pipe,
    (c) => { return isEqual(c.curve.data.kind, kind); },
  );
  let _pipe$2 = $result.map(_pipe$1, process_curve);
  return $result.lazy_unwrap(_pipe$2, empty_display);
}

export function view(model) {
  let state = $bright.state(model);
  return $bool.guard(
    $state.is_analytics_hidden(state),
    $l.fragment(
      toList([
        $h.text(
          "Analytics will show up here 30 days after you start using the platform.",
        ),
      ]),
    ),
    () => {
      return $l.fragment(
        toList([
          $s.grid_container(
            toList([]),
            toList([
              pie_plot(
                find_curve(state.analytics, new $metrics.AnswerValidated()),
                find_curve(state.analytics, new $metrics.QuestionCreated()),
              ),
              bar_plot(
                find_curve(state.analytics, new $metrics.AnswerValidated()),
              ),
              bar_plot(
                find_curve(state.analytics, new $metrics.QuestionCreated()),
              ),
              bar_plot(
                find_curve(state.analytics, new $metrics.ProposalCreated()),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}
